/**
 * Passthrough transformers for components that don't need data transformation
 * These transformers receive API data and return it as-is
 */

/**
 * Generic passthrough transformer that returns data unchanged
 */
export const passthroughTransformer = (apiData: unknown): unknown => {
  return apiData;
};

/**
 * Header title transformer - passes data through unchanged
 */
export const transformHeaderTitle = (apiData: unknown): unknown => {
  return apiData;
};

/**
 * Filter plans transformer - passes data through unchanged
 */
export const transformFilterPlans = (apiData: unknown): unknown => {
  return apiData;
};

/**
 * Itinerary info transformer - extracts travelDetails from API data
 */
export const transformItineraryInfo = (apiData: unknown): unknown => {
  return apiData;
};

/**
 * Persuasion transformer - passes data through unchanged
 */
export const transformPersuasion = (apiData: unknown): unknown => {
  return apiData;
};
